module.exports = __webpack_public_path__ + "static/media/Surabhi Prasad.8b73c6c8.jpg";